// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__30PUR","selects":"Documents_selects__2cdrl"};